import 'core-js/features/array/find';
import 'core-js/es/math/trunc';
import CIResponsive from './ci.service';


window.CIResponsive = CIResponsive;